// Static content sourced from www.smilesofloudoun.com
// Images are mirrored locally in /public/site-assets for resilience
const CDN = "/site-assets";

export const ASSETS = {
  logo: "https://customer-assets.emergentagent.com/job_teeth-makeover-2/artifacts/andri1pa_Smiles%20Of%20Loudoun%202%20logo.jpg",
  smileArc: "https://customer-assets.emergentagent.com/job_teeth-makeover-2/artifacts/ahfez877_smiles%20of%20Loudoun%20logo.jpg",
  heroVideo: `${CDN}/hero.mp4`,
  sunDivider: `${CDN}/sun-hr.webp`,
  opening: `${CDN}/opening-home.webp`,
  drPortrait: `${CDN}/dr.webp`,
  invisalign: `${CDN}/invisalign-pic.webp`,
  botox: `${CDN}/botox-pic.webp`,
  office1: `${CDN}/office-home1.webp`,
  office2: `${CDN}/office-home2.webp`,
  office3: `${CDN}/office-home3.webp`,
  office4: `${CDN}/office-home4.webp`,
  office5: `${CDN}/office-home5.webp`,
  ada: `${CDN}/ada.webp`,
  icoi: `${CDN}/icoi.webp`,
  agd: `${CDN}/agd.webp`,
  serviceIcons: {
    invisalign: `${CDN}/show1.webp`,
    gum: `${CDN}/show2.webp`,
    whitening: `${CDN}/show3.webp`,
    veneers: `${CDN}/show4.webp`,
    crowns: `${CDN}/show5.webp`,
    iv: `${CDN}/show6.webp`,
    implants: `${CDN}/show7.webp`,
    bridges: `${CDN}/show8.webp`,
  },
};

export const PRACTICE = {
  name: "Smiles of Loudoun",
  phone: "571-510-3034",
  phoneHref: "tel:571-510-3034",
  address: "430 Harrison Street SE, Leesburg, VA 20175",
  mapUrl: "https://g.page/smiles-of-loudoun?share",
  appointmentUrl:
    "https://book2.getweave.com/7af65575-fcc5-4641-b267-152f93bc72a7/request-appointment?source=WEBSITE",
  payOnlineUrl: "https://weavebillpay.com/66db1e76",
  referralUrl:
    "https://www.smilesofloudoun.com/wp-content/uploads/2026/04/SMILES_OF_LOUDOUN_REFERRAL_PAD2.pdf",
  reviewsUrl: "https://search.google.com/local/reviews?placeid=ChIJLXQEwV4XtokRgVHykOctc-A",
  googleWriteReviewUrl: "https://search.google.com/local/writereview?placeid=ChIJLXQEwV4XtokRgVHykOctc-A",
  googlePlaceUrl: "https://www.google.com/maps/place/?q=place_id:ChIJLXQEwV4XtokRgVHykOctc-A",
  languages: ["English", "French", "Farsi", "Spanish"],
  hours: [
    { d: "Monday", t: "9:00 AM – 6:00 PM" },
    { d: "Tuesday", t: "9:00 AM – 6:00 PM" },
    { d: "Wednesday", t: "9:00 AM – 6:00 PM" },
    { d: "Thursday", t: "9:00 AM – 6:00 PM" },
    { d: "Friday", t: "9:00 AM – 4:00 PM" },
    { d: "Sat – Sun", t: "By Appointment" },
  ],
};

export const NAV = [
  { label: "Home", to: "/" },
  {
    label: "About us",
    to: "/#about",
    children: [
      { label: "Meet the Doctors", to: "/#about" },
      { label: "Office Tour", to: "/#gallery" },
    ],
  },
  { label: "Services", to: "/services", children: [
    { label: "Cosmetic Dentistry", to: "/services#cat-cosmetic" },
    { label: "Restorative Dentistry", to: "/services#cat-restorative" },
    { label: "Dental Implants", to: "/services#cat-implants" },
    { label: "General & Family Dentistry", to: "/services#cat-general" },
    { label: "Oral Surgery", to: "/services#cat-surgery" },
    { label: "Periodontics", to: "/services#cat-periodontics" },
    { label: "Sedation Dentistry", to: "/services#cat-sedation" },
  ] },
  { label: "Patient Resources", to: "/financial-options", children: [
    { label: "Financial Options", to: "/financial-options" },
    { label: "Patient Forms", to: "https://www.smilesofloudoun.com/Patient-Information/Patient-Forms/", external: true },
    { label: "Patient Specials", to: "/#special" },
  ] },
  { label: "Facial Aesthetics", to: "/facial-aesthetics", children: [
    { label: "BOTOX® Treatments", to: "/facial-aesthetics#botox" },
    { label: "JUVÉDERM®", to: "/facial-aesthetics#juvederm" },
  ] },
  { label: "Contact us", to: "/contact" },
];

export const CATEGORIES = [
  {
    slug: "cosmetic",
    title: "Cosmetic Dentistry",
    blurb:
      "Enhance the natural beauty of your smile with treatments designed to transform — discreetly.",
  },
  {
    slug: "restorative",
    title: "Restorative Dentistry",
    blurb:
      "Rebuild strength, function and confidence for teeth that are worn, broken or missing.",
  },
  {
    slug: "implants",
    title: "Dental Implants",
    blurb:
      "The gold standard for replacing missing teeth — designed to last a lifetime.",
  },
  {
    slug: "general",
    title: "General & Family Dentistry",
    blurb:
      "Preventive, conservative care for every member of your family at every age.",
  },
  {
    slug: "surgery",
    title: "Oral Surgery",
    blurb:
      "Advanced surgical care performed in-office by doctors with Harvard-trained expertise.",
  },
  {
    slug: "periodontics",
    title: "Periodontics",
    blurb:
      "Gum and supporting-tissue care — the foundation of every healthy smile.",
  },
  {
    slug: "sedation",
    title: "Sedation Dentistry",
    blurb:
      "Comfort-first dentistry for anxious patients and complex treatment days.",
  },
];

export const SERVICES = [
  {
    slug: "invisalign",
    title: "Invisalign®",
    tag: "Stop scrolling, start straightening.",
    short:
      "Discreet, removable clear aligners crafted to your bite — for adults and teens.",
    icon: "invisalign",
    size: "large",
    category: "cosmetic",
    featured: true,
    long: [
      "Invisalign® treatment is a clear, modern approach to straightening teeth without the noticeable wires and brackets of traditional braces. At Smiles of Loudoun, our dentists are proud to offer Invisalign aligners to patients seeking a discreet and convenient way to align their teeth and improve their smiles.",
      "Invisalign treatment uses a series of custom-made, clear plastic aligners that fit snugly over your teeth. Each aligner applies gentle pressure, gradually moving your teeth closer to the desired position. Patients switch to a new aligner every one to two weeks, making steady progress toward their ideal smile.",
    ],
    bullets: [
      "Virtually invisible — straighten teeth without visible brackets",
      "Removable and flexible — eat and brush normally",
      "Increased comfort — smooth plastic, gentle on cheeks & gums",
      "Fewer office visits than traditional braces",
      "Effective for crowding, spacing, overbites and underbites",
    ],
    faq: [
      {
        q: "How does Invisalign treatment work?",
        a: "A series of custom, clear plastic aligners gradually shift teeth into place. Each aligner is worn for one to two weeks before switching to the next.",
      },
      {
        q: "How long does Invisalign treatment take?",
        a: "On average, most patients achieve their desired results within 12 to 18 months, though some may see improvements sooner.",
      },
      {
        q: "Are Invisalign aligners comfortable?",
        a: "Yes. Smooth, custom-fit plastic — no wires or brackets means much less irritation than braces.",
      },
      {
        q: "Can I eat normally with Invisalign aligners?",
        a: "Aligners are removable, so you can eat your favorite foods without restrictions — just remove them while eating and drinking anything but water.",
      },
      {
        q: "How often do I need to wear my aligners?",
        a: "For best results, wear them 20 to 22 hours a day — only removing for eating, drinking, brushing and flossing.",
      },
    ],
  },
  {
    slug: "cosmetic-gum-contouring",
    title: "Cosmetic Gum Treatment",
    tag: "Goodbye gummy smile.",
    short: "Gentle reshaping to reveal more of the tooth you already love.",
    icon: "gum",
    size: "small",
    category: "periodontics",
    featured: true,
    long: [
      "Cosmetic gum contouring (also called a gum lift) gently reshapes the gum line to reveal more of your natural tooth and create a balanced, even smile.",
      "Performed with precision soft-tissue lasers, the treatment is quick, comfortable, and produces immediate visible results — with minimal recovery time.",
    ],
    bullets: [
      "Corrects a “gummy smile” for better proportion",
      "Evens out an asymmetrical gum line",
      "Comfortable laser treatment with minimal downtime",
      "Often combined with veneers or whitening",
    ],
    faq: [
      { q: "Is gum contouring painful?", a: "No — laser treatment is very gentle and we numb the area beforehand for added comfort." },
      { q: "How long does it last?", a: "Results are permanent in most cases, especially when paired with good oral hygiene." },
    ],
  },
  {
    slug: "teeth-whitening",
    title: "Teeth Whitening",
    tag: "A full set of pearly whites.",
    short: "Professional-strength brightening — in office or take-home trays.",
    icon: "whitening",
    size: "small",
    category: "cosmetic",
    featured: true,
    long: [
      "Years of coffee, tea, wine and time can leave even the healthiest teeth looking dull. Our professional whitening lifts deep stains safely — far beyond what store-bought strips can do.",
      "Choose a one-visit in-office treatment for dramatic same-day results, or take home custom trays for whitening on your schedule.",
    ],
    bullets: [
      "Safe, dentist-supervised whitening",
      "Custom-fit trays for an even result",
      "In-office option for same-day brightening",
      "Beautiful results that last when maintained",
    ],
    faq: [
      { q: "Is whitening safe for my enamel?", a: "Yes — professional whitening is safe when used as directed, with much lower sensitivity risk than over-the-counter options." },
      { q: "How long do results last?", a: "Typically 1–2 years with periodic at-home touch-ups." },
    ],
  },
  {
    slug: "porcelain-veneers",
    title: "Porcelain Veneers",
    tag: "A stunning, natural new smile.",
    short:
      "Hand-crafted, paper-thin shells that enhance your natural beauty.",
    icon: "veneers",
    size: "medium",
    category: "cosmetic",
    featured: true,
    long: [
      "Porcelain veneers are wafer-thin shells crafted to bond to the front of your teeth — instantly correcting shape, color, length and minor alignment issues in just a few visits.",
      "Every veneer is shaped to your face, smile and personality for a result that looks completely natural — not “done.”",
    ],
    bullets: [
      "Corrects chips, gaps, stains and small alignment issues",
      "Lifelike, stain-resistant porcelain",
      "Minimally invasive with conservative prep",
      "Long-lasting, beautiful results",
    ],
    faq: [
      { q: "How long do veneers last?", a: "With proper care, porcelain veneers commonly last 10 to 15 years or longer." },
      { q: "Will veneers damage my teeth?", a: "No — a very thin layer of enamel is reshaped to create a strong, conservative bond." },
    ],
  },
  {
    slug: "dental-crowns",
    title: "Dental Crowns",
    tag: "Restore shape, size & strength.",
    short:
      "Custom crowns that protect a tooth while looking entirely your own.",
    icon: "crowns",
    size: "small",
    category: "restorative",
    featured: true,
    long: [
      "When a tooth is cracked, badly worn, or has had a root canal, a dental crown restores its strength while looking and feeling like the tooth you remember.",
      "We craft crowns from durable, lifelike porcelain or zirconia, shaded to match your natural smile.",
    ],
    bullets: [
      "Protects cracked, weakened, or treated teeth",
      "Lifelike porcelain & zirconia options",
      "Custom-shaded to blend with neighboring teeth",
      "Restores comfortable chewing function",
    ],
    faq: [
      { q: "How long do crowns last?", a: "Typically 10 to 20 years with good oral hygiene." },
    ],
  },
  {
    slug: "iv-sedation",
    title: "IV Sedation",
    tag: "Pain-free dentistry, truly.",
    short: "Comfort-first sedation administered by trained doctors in-office.",
    icon: "iv",
    size: "small",
    category: "sedation",
    featured: true,
    long: [
      "For patients with dental anxiety or complex treatment needs, IV sedation offers deep relaxation throughout the visit — most patients remember almost nothing of the appointment.",
      "All sedation is administered and continuously monitored by Dr. Yopa, who is specifically trained in oral & maxillofacial surgery and sedation.",
    ],
    bullets: [
      "Ideal for dental anxiety or longer procedures",
      "Doctor-administered & continuously monitored",
      "Wake up feeling rested, not traumatized",
      "Complete multiple treatments in one visit",
    ],
    faq: [
      { q: "Will I be unconscious?", a: "IV sedation produces deep relaxation — you remain responsive but most patients don't remember the procedure." },
      { q: "How long until I can drive?", a: "A friend or family member should drive you home; full recovery is usually within 24 hours." },
    ],
  },
  {
    slug: "dental-implants",
    title: "Dental Implants",
    tag: "Eat the hard foods. Confidently.",
    short:
      "Surgical-grade titanium roots with crowns that feel like your own.",
    icon: "implants",
    size: "medium",
    category: "implants",
    featured: true,
    long: [
      "Dental implants are the gold standard for replacing missing teeth — a titanium post anchors into your jawbone, supporting a custom crown that looks, feels and functions like a natural tooth.",
      "Implants preserve bone, stabilize neighboring teeth, and last decades with proper care.",
    ],
    bullets: [
      "Looks, feels and functions like a natural tooth",
      "Preserves jawbone and facial structure",
      "Doesn't rely on neighboring teeth for support",
      "Designed to last a lifetime with proper care",
    ],
    faq: [
      { q: "Am I a candidate?", a: "Most adults with good general health and adequate bone density are good candidates — Dr. Yopa is trained in implantology at NYU." },
      { q: "How long is the process?", a: "Implant placement to final crown typically spans 3 to 6 months as the implant integrates with your jawbone." },
    ],
  },
  {
    slug: "dental-bridges",
    title: "Dental Bridges",
    tag: "Fill the gap, keep the smile.",
    short:
      "Fixed restorations that bridge missing teeth in a single visit plan.",
    icon: "bridges",
    size: "small",
    category: "restorative",
    featured: true,
    long: [
      "A dental bridge replaces one or more missing teeth by anchoring a natural-looking false tooth (or teeth) to the neighboring teeth or implants.",
      "It restores your smile, your bite, and prevents remaining teeth from drifting out of place.",
    ],
    bullets: [
      "Fills the gap of one or more missing teeth",
      "Restores comfortable chewing & speaking",
      "Looks beautifully natural",
      "Prevents shifting of adjacent teeth",
    ],
    faq: [
      { q: "How long does a bridge last?", a: "Typically 10 to 15 years with good oral hygiene and routine cleanings." },
    ],
  },

  /* ---------- Additional sub-services (per-category) ---------- */
  {
    slug: "dental-bonding",
    title: "Dental Bonding",
    tag: "Quick fixes for chips & gaps.",
    short: "Tooth-colored resin sculpted in a single visit to repair chips, gaps and minor flaws.",
    icon: "veneers",
    category: "cosmetic",
    long: [
      "Dental bonding uses a tooth-colored composite resin that we sculpt and harden directly onto your tooth — restoring chips, closing small gaps, and reshaping minor imperfections.",
      "Most bondings are completed in a single visit, with no impressions and no laboratory wait time.",
    ],
    bullets: [
      "Repairs chipped, cracked or worn teeth",
      "Closes small gaps for a more even smile",
      "Single-visit treatment with no anesthesia in most cases",
      "Affordable, conservative alternative to veneers",
    ],
    faq: [
      { q: "How long does bonding last?", a: "Bonding typically lasts 5 to 10 years depending on the location and your habits." },
      { q: "Will it stain?", a: "Composite resin can pick up stains over time — coffee, red wine and tobacco are the usual culprits." },
    ],
  },
  {
    slug: "composite-fillings",
    title: "Composite Fillings",
    tag: "Invisible repairs for cavities.",
    short: "Mercury-free, tooth-colored fillings that bond directly to your tooth.",
    icon: "crowns",
    category: "restorative",
    long: [
      "Composite (tooth-colored) fillings restore decayed or damaged teeth with a material that blends seamlessly with your natural enamel.",
      "Unlike older silver/amalgam fillings, composites bond directly to the tooth — strengthening the structure and requiring less drilling.",
    ],
    bullets: [
      "Virtually invisible — matched to your tooth shade",
      "Mercury-free and metal-free",
      "Bonds to the tooth for added strength",
      "Conservative — preserves more of your natural tooth",
    ],
    faq: [
      { q: "How long do they last?", a: "Composite fillings typically last 7 to 10 years depending on size and bite forces." },
    ],
  },
  {
    slug: "dentures",
    title: "Dentures",
    tag: "Confident smile, full bite.",
    short: "Custom partial and complete dentures crafted for a comfortable, lifelike fit.",
    icon: "bridges",
    category: "restorative",
    long: [
      "Modern dentures are lighter, more comfortable and far more natural-looking than the dentures of even a decade ago.",
      "We craft both full and partial dentures, and can stabilize them with mini-implants for a no-slip fit when chewing and speaking.",
    ],
    bullets: [
      "Lifelike, custom-shaded teeth",
      "Partial and complete options",
      "Optional implant stabilization for a secure fit",
      "Restores chewing, speech and facial volume",
    ],
    faq: [
      { q: "How long is the process?", a: "From first impressions to final fitting, dentures typically take 3 to 6 weeks." },
      { q: "Can dentures be implant-supported?", a: "Yes — a small number of implants can dramatically stabilize an upper or lower denture." },
    ],
  },
  {
    slug: "root-canal-therapy",
    title: "Root Canal Therapy",
    tag: "Save your tooth, painlessly.",
    short:
      "Modern, comfortable root canal therapy that relieves pain and rescues a damaged tooth.",
    icon: "crowns",
    category: "restorative",
    long: [
      "Root canal therapy treats infection or inflammation deep inside a tooth — relieving pain and allowing you to keep your natural tooth instead of extracting it.",
      "With modern technology and anesthesia, the procedure is typically no more uncomfortable than getting a filling.",
    ],
    bullets: [
      "Relieves deep tooth pain caused by infection",
      "Preserves your natural tooth",
      "Single or two-visit treatment in most cases",
      "Completed under comfortable anesthesia",
    ],
    faq: [
      { q: "Is a root canal painful?", a: "Most patients say modern root canals feel about the same as a regular filling." },
      { q: "Will I need a crown after?", a: "Most back teeth do — a crown protects the treated tooth from cracking under chewing forces." },
    ],
  },
  {
    slug: "dental-cleanings-exams",
    title: "Dental Cleanings & Exams",
    tag: "Twice a year, all your life.",
    short:
      "Comprehensive cleanings and exams to prevent problems before they start.",
    icon: "whitening",
    category: "general",
    long: [
      "Routine cleanings and exams are the single most important investment in your long-term oral health. Every six months, our hygienists remove plaque and tartar buildup, and our dentists screen for cavities, gum disease and oral cancer.",
      "First-time patients can take advantage of our $129 New Patient Special — comprehensive exam, digital X-rays, and a thorough cleaning.",
    ],
    bullets: [
      "Plaque and tartar removal",
      "Digital X-rays as needed",
      "Oral cancer screening",
      "Gentle polishing and fluoride treatment",
    ],
    faq: [
      { q: "How often should I come in?", a: "Most patients should be seen every 6 months. Patients with periodontal disease may need more frequent visits." },
    ],
  },
  {
    slug: "emergency-dentistry",
    title: "Emergency Dentistry",
    tag: "Same-day care when it hurts.",
    short: "Pain, swelling, a knocked-out tooth — call us and we'll see you fast.",
    icon: "iv",
    category: "general",
    long: [
      "Dental emergencies don't wait. Whether it's severe pain, a knocked-out tooth, a broken crown, or a sudden swelling, call our office and we'll make every effort to see you the same day.",
      "If we can't get you in immediately, we'll talk you through what to do until we can.",
    ],
    bullets: [
      "Same-day appointments for urgent care",
      "Pain relief, infection control, and tooth-saving treatment",
      "Step-by-step phone guidance for after-hours emergencies",
    ],
    faq: [
      { q: "What counts as a dental emergency?", a: "Severe pain, a knocked-out tooth, bleeding that doesn't stop, facial swelling, and a broken crown or filling all qualify — call us immediately." },
      { q: "What do I do with a knocked-out tooth?", a: "Hold it by the crown (not the root), rinse gently, and place it in milk or saliva. Call us right away — minutes count." },
    ],
  },
  {
    slug: "night-guards",
    title: "Night Guards",
    tag: "Stop grinding before it costs you.",
    short:
      "Custom-fit guards that protect your teeth and jaw from nighttime grinding.",
    icon: "whitening",
    category: "general",
    long: [
      "If you wake up with a sore jaw or headache — or your bedmate hears grinding at night — a custom night guard can protect your teeth from cracking and your jaw from chronic strain.",
      "We take a digital scan and fit a custom acrylic guard that feels far less bulky than over-the-counter options.",
    ],
    bullets: [
      "Prevents tooth fractures from nighttime grinding (bruxism)",
      "Reduces jaw pain and tension headaches",
      "Slim, comfortable, custom-fit acrylic",
      "Lasts 5+ years with proper care",
    ],
    faq: [
      { q: "How is this different from a store-bought guard?", a: "Custom guards are slimmer, more comfortable, and fit your bite exactly — leading to far better protection and compliance." },
    ],
  },
  {
    slug: "tmj-treatment",
    title: "TMJ Treatment",
    tag: "Relief for jaw pain & headaches.",
    short:
      "Conservative, layered TMJ care — from custom splints to BOTOX® for muscle tension.",
    icon: "iv",
    category: "general",
    long: [
      "TMJ (temporomandibular joint) disorders cause jaw pain, clicking, headaches and even neck pain. We take a conservative, layered approach — starting with a custom splint and adding therapies like BOTOX® or physical therapy as needed.",
      "Most patients see meaningful relief within a few weeks of starting treatment.",
    ],
    bullets: [
      "Custom-fit splint/orthotic to reposition the jaw",
      "BOTOX® injections for chronic muscle tension",
      "Bite adjustments where appropriate",
      "Referrals for physical therapy when indicated",
    ],
    faq: [
      { q: "Do I need surgery?", a: "Almost never. The vast majority of TMJ disorders resolve with conservative care." },
    ],
  },
  {
    slug: "dental-sealants",
    title: "Dental Sealants",
    tag: "Cavity prevention for kids.",
    short:
      "A thin protective coating that shields your child's molars from decay.",
    icon: "whitening",
    category: "general",
    long: [
      "Dental sealants are a thin, plastic coating painted onto the chewing surfaces of the back molars — sealing out food particles and bacteria that cause decay.",
      "Sealants are quick, painless, and one of the most cost-effective ways to prevent cavities in school-aged children.",
    ],
    bullets: [
      "Reduces cavity risk on chewing surfaces by up to 80%",
      "Quick, painless application in one short visit",
      "Lasts several years with normal wear",
      "Often covered by dental insurance for children",
    ],
    faq: [
      { q: "At what age should my child get sealants?", a: "Typically as soon as the permanent molars come in — around age 6 for the first molars and age 12 for the second molars." },
    ],
  },
  {
    slug: "wisdom-teeth-removal",
    title: "Wisdom Teeth Removal",
    tag: "In-office surgical care.",
    short:
      "Comfortable extraction of impacted or troublesome wisdom teeth — sedation available.",
    icon: "iv",
    category: "surgery",
    long: [
      "Wisdom teeth often emerge sideways or only partially — causing pain, infection, and crowding of neighboring teeth. Dr. Yopa is trained in oral & maxillofacial surgery at Harvard and removes wisdom teeth comfortably right in our office.",
      "Most patients choose IV sedation and remember nothing of the procedure.",
    ],
    bullets: [
      "Removed in-office by an experienced surgeon",
      "IV sedation available for a stress-free experience",
      "Reduces risk of infection, crowding, and cysts",
      "Most patients recover in 3–5 days",
    ],
    faq: [
      { q: "Do I have to remove all four?", a: "Not always. We only recommend removal of teeth that are impacted, infected, or threatening neighboring teeth." },
    ],
  },
  {
    slug: "bone-grafting",
    title: "Bone Grafting",
    tag: "Restore your foundation.",
    short:
      "Rebuild bone density to support implants or restore facial structure.",
    icon: "implants",
    category: "surgery",
    long: [
      "When teeth have been missing for a long time, the underlying jawbone shrinks. Bone grafting adds volume back to that bone — creating a solid foundation for dental implants or restoring facial contour.",
      "Modern grafting materials integrate beautifully and the procedure is usually completed under local anesthesia in a single visit.",
    ],
    bullets: [
      "Creates a stable foundation for dental implants",
      "Preserves bone after tooth extraction (socket preservation)",
      "Restores facial contour and supports lips & cheeks",
      "Performed in-office under local or IV sedation",
    ],
    faq: [
      { q: "How long does the graft take to heal?", a: "Most grafts integrate within 3 to 6 months, after which an implant can be placed." },
    ],
  },
  {
    slug: "oral-conscious-sedation",
    title: "Oral Conscious Sedation",
    tag: "A small pill, a relaxed visit.",
    short:
      "Take a mild sedative before your appointment to take the edge off any anxiety.",
    icon: "iv",
    category: "sedation",
    long: [
      "Oral conscious sedation uses a single prescribed pill taken before your appointment to ease anxiety and help you feel deeply relaxed throughout your visit.",
      "You'll remain awake and able to respond, but most patients feel drowsy and remember very little. Perfect for mild-to-moderate dental anxiety.",
    ],
    bullets: [
      "Take a single pill before your visit",
      "Feel relaxed without IV sedation",
      "Ideal for mild-to-moderate dental anxiety",
      "Requires a driver to and from the appointment",
    ],
    faq: [
      { q: "Will I be asleep?", a: "No — you'll feel deeply relaxed but stay awake and responsive. Most patients remember very little of the visit." },
    ],
  },
];

export const TESTIMONIALS = [
  {
    quote:
      "I enjoyed the service I received from Dr. Yopa and his staff. They took the time to talk to me about my dental issue and also educated me every step of the way. I am a lifelong patient of Smiles of Loudoun.",
    author: "Rashid F.",
  },
  {
    quote:
      "Great welcoming and friendly staff. Very professional and straight forward. They told me exactly what I needed done and when I will be comfortable to start the process. The best dental office in the area! I highly recommend Smiles of Loudoun for everyone!",
    author: "Leeann L.",
  },
  {
    quote:
      "Thank you Smiles of Loudoun for a wonderful experience! My son enjoyed every minute of the treatment he got. The doctor was very patient and thorough. Definitely will be bringing my entire family here.",
    author: "Soheila Y.",
  },
  {
    quote:
      "Wow, what a great experience! Everyone is extremely professional and the quality of care is exceptional. Awesome staff and doctor! I would highly recommend them.",
    author: "Avasa J.",
  },
];

export const DOCTORS = [
  {
    name: "Dr. Steve Yopa",
    title: "General Dentist",
    bio: [
      "Dr. Steve Yopa is a general dentist with training in endodontics, oral surgery and much more. When he moved from Cameroon to the United States, he attended George Mason University in Fairfax, Virginia, and graduated with a Bachelor of Science in biochemistry and a minor in global and community health.",
      "He then went on to attend Meharry Medical College School of Dentistry in Nashville, Tennessee, where he received his Doctor of Dental Surgery. During his matriculation, he completed many externships at different institutions including Harvard School of Dental Medicine and Boston University Henry M. Goldman School of Dental Medicine with an emphases in oral and maxillofacial surgery and oral medicine. He is also proud to have been the only one in his class to receive the outstanding student leader award from the American College of Dentists. After graduating from dental school, he moved to New York to complete his post graduate training (general practice residency) at Bronx-Lebanon Hospital Center. He also completed an oral health leadership development program so he can now educate and treat his patients with a 'ground-up' approach.",
      "Dr. Yopa also received a two-year fellowship in oral implantology from the NYU Dental Post-Graduate Program. He is now recognized as a fellow of the International Congress of Oral Implantologists (ICOI).",
      "Dr. Yopa helps his patients achieve beautiful smiles and brings his superior aesthetic skills to everything he does from aesthetic (non-metallic) fillings, veneers, crowns, bone grafting and implant restoration. Dr. Yopa speaks English and French.",
    ],
  },
  {
    name: "Dr. Serena Ide Noumy",
    title: "General Dentist",
    bio: [
      "Born and raised in Cameroon, Dr. Serena Ide Noumy began a transformative journey in 2005 when she moved to the United States. She settled in Richmond, Virginia, where she pursued her academic goals at Virginia Commonwealth University, earning both her undergraduate and dental degrees. This comprehensive education laid a strong foundation, equipping her with the skills and knowledge needed to care for patients with compassion, respect and clinical excellence.",
      "After completing her studies, Dr. Noumy completed a one-year residency in Arizona, where she refined her practical skills in a fast-paced healthcare environment. She then relocated to Dallas, Texas, where she practiced dentistry for five years. During this time, she developed a deeper appreciation for the complexities of patient care and the importance of building meaningful, long-term relationships within the community.",
      "Despite her rewarding experience in Texas, Dr. Noumy felt a strong pull back to Virginia, the state she had come to consider home. Motivated by a desire to give back to the community that supported her early career, she returned with a renewed commitment to providing exceptional care. She treats every patient like family and focuses on educating individuals about the importance of oral health. As an active member of multiple dental associations, she remains current with the latest advancements in dentistry and is dedicated to continuous professional development.",
      "Beyond dentistry, Dr. Noumy values balance and connection in her personal life. She enjoys volunteering, traveling, working out and dancing salsa. These passions not only enrich her own life but also allow her to contribute meaningfully to the communities she serves.",
      "Today, Dr. Noumy is honored to serve her community with dignity and compassion, striving to make a lasting and positive impact in the lives of her patients.",
    ],
  },
  {
    name: "Dr. Salar Ebrahimi",
    title: "Dental Anesthesiologist",
    bio: [
      "Dr. Salar Ebrahimi grew up in Southern California with a passion for art and medicine. Throughout his life, Dr. Ebrahimi knew he wanted to help people through his profession and found his passion of art in the field of dentistry. Dr. Ebrahimi went on to gain his Bachelor of Science in biology, his master's degree in biomedical science and his Doctor of Dental Surgery from Howard University College of Dentistry in Washington, DC.",
      "Dr. Ebrahimi was inducted into the prestigious National Dental Honor Society after excelling in dental school. He is also a member of the American Dental Association® and the American Society of Dental Anesthesia. In his spare time, Dr. Ebrahimi enjoys traveling, spending time with his family and creating art.",
    ],
  },
];

export const AFFILIATIONS = [
  { label: "American Dental Association", short: "ADA", logo: ASSETS.ada, url: "https://www.ada.org/" },
  { label: "International Congress of Oral Implantologists", short: "ICOI", logo: ASSETS.icoi, url: "https://www.icoi.org/" },
  { label: "Academy of General Dentistry", short: "AGD", logo: ASSETS.agd, url: "https://www.agd.org/" },
];

export const GALLERY = [
  ASSETS.office1,
  ASSETS.office2,
  ASSETS.office3,
  ASSETS.office4,
  ASSETS.office5,
];
